import {
    Paper,
    createStyles,
    TextInput,
    PasswordInput,
    Button,
    Title,
} from '@mantine/core';
import {APPLICATION_DISPLAY_NAME} from "../../../settings";
import {useForm} from "@mantine/form";
import {ILoginValues} from "../../../api/User/User.types";
import useUserStore from "../../../data/User.store";

const useStyles = createStyles((theme) => ({
    wrapper: {
        minHeight: 900,
        height: "100%",
        backgroundSize: 'cover',
        backgroundImage:
            'url(https://images.unsplash.com/photo-1484242857719-4b9144542727?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1280&q=80)',
    },

    form: {
        borderRight: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3]
        }`,
        height: "100%",
        minHeight: 900,
        maxWidth: 450,
        paddingTop: 80,

        [`@media (max-width: ${theme.breakpoints.sm}px)`]: {
            maxWidth: '100%',
        },
    },

    title: {
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
        fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    },

    logo: {
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
        width: 120,
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}));


export function AuthenticationImage() {
    const {login, loadingUser} = useUserStore();
    const {classes} = useStyles();

    const form = useForm<ILoginValues>({
        initialValues: {
            username: '',
            password: '',
            persist: false,
        }
    })

    async function onSubmit() {
        let response = await login(form.values);
        if(!response) form.setErrors({password: 'Invalid password or username.'})
    }

    return (
        <div className={classes.wrapper}>
            <Paper className={classes.form} radius={0} p={30}>
                <Title order={2} className={classes.title} align="center" mt="md" mb={50}>
                    Welcome back to {APPLICATION_DISPLAY_NAME}
                </Title>
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <TextInput label="Username" placeholder="Username"
                               size="md" {...form.getInputProps('username')}/>
                    < PasswordInput label="Password" placeholder="Your password" mt="md" size="md"
                                    {...form.getInputProps('password')}/>
                    {/*<Checkbox label="Keep me logged in" mt="xl" size="sm"*/}
                    {/*          {...form.getInputProps('persist')}/>*/}
                    <Button fullWidth mt="xl" size="md" type="submit" loading={loadingUser}>
                        Login
                    </Button>
                    <>v.2023.03.23</>
                </form>
            </Paper>
        </div>
    );
}